import type { RootSchema } from "../../redux/reducers";

type AnalyticsStateGetter = () => RootSchema;

let getState: AnalyticsStateGetter | undefined;

/**
 * Registers a Redux state getter so direct trackEvent() calls can attach
 * base metadata (trial_user, tenantType, app_id, etc.) without callers
 * needing to pass state explicitly.
 */
export const registerAnalyticsStateGetter = (getter: AnalyticsStateGetter) => {
  getState = getter;
};

export const getAnalyticsState = (): RootSchema | undefined => {
  try {
    return getState?.();
  } catch {
    return undefined;
  }
};
